export const items = {
  items: [
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae',
      extTargetingId: 'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae-extTargetingId',
      title: '2050 Yonge copy - DO NOT USE - (MOD) Allergy',
      createdDate: '2022-01-20T17:10:22',
      updatedDate: '2022-07-15T03:07:14',
      startDate: '2021-05-09T00:00:00',
      endDate: '2221-05-10T23:59:59',
      displayRank: 1,
      discounts: [],
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Salad Extras',
          shortDescription: null,
          longDescription: null,
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68ddd_2.jpg',
          ],
          mediumImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68de5_1-md.jpg',
          ],
        },
        {
          langCode: 'FR',
          title: 'fr',
          shortDescription: '',
          longDescription: null,
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68ddd_2.jpg',
          ],
          mediumImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68de5_1-md.jpg',
          ],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {
        PROPERTY_1: '68a283e4-344e-4e3e-886d-979c9ac01698',
        PROPERTY_2: '491b6e2d-e87b-4feb-8f3b-7af4710fc7c3',
      },
      privateAttributes: {
        SILVERWARE_PRICE_ID: '405f85cf-fcac-4962-840a-178e2de3153b',
      },
      storeIds: ['f58c34ac-7ee0-4d39-a663-ef5881b0a217'],
      storeInfos: [
        {
          storeId: 'storeid1',
          title: 'Test store 1',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
        },
      ],
      itemId: '60997a3a60b20eb4a15d8d83',
      price: 0,
      optionGroupIds: ['60997a3960b20eb4a15d8c92'],
      optionGroupSettings: [
        {
          optionGroupId: '60997a3960b20eb4a15d8c92',
          displayRank: null,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 1,
          minItemSelections: 1,
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MAIN',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '2e203cf5-1f44-41f6-b0db-e9e527fb37a9',
      extTargetingId: '2e203cf5-1f44-41f6-b0db-e9e527fb37a9-extTargetingId',
      title: '2050 Yonge copy - DO NOT USE - 1.5Lbs Wings',
      createdDate: '2021-05-10T18:23:54',
      updatedDate: '2022-06-28T15:02:09',
      startDate: '2021-05-09T00:00:00',
      endDate: '2221-05-10T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: '1.5Lbs Wings',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {
        SILVERWARE_PRICE_ID: 'b36f2b09-e68f-4ab2-81c0-144231f4ba36',
      },
      storeIds: ['f58c34ac-7ee0-4d39-a663-ef5881b0a217'],
      storeInfos: [
        {
          storeId: 'storeid1',
          title: 'Test store 1',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
        },
        {
          storeId: 'storeid2',
          title: 'Test store 2',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
        },
      ],
      itemId: '60997a3a60b20eb4a15d8d75',
      price: 0,
      optionGroupIds: ['60997a3960b20eb4a15d8c99', '60997a3960b20eb4a15d8c89'],
      optionGroupSettings: [
        {
          optionGroupId: '60997a3960b20eb4a15d8c99',
          displayRank: null,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 1,
          minItemSelections: 1,
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
        },
        {
          optionGroupId: '60997a3960b20eb4a15d8c89',
          displayRank: null,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 1,
          minItemSelections: 1,
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: '6bf025bd-2258-48f7-a7f0-71d5e802794b',
      extTargetingId: '6bf025bd-2258-48f7-a7f0-71d5e802794b-extTargetingId',
      title: '2050 Yonge copy - DO NOT USE - 2 Glass',
      createdDate: '2021-05-10T18:23:53',
      updatedDate: '2021-05-10T18:23:53',
      startDate: '2021-05-09T18:23:53',
      endDate: '2221-05-10T18:23:53',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: '2 Glass',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {
        SILVERWARE_PRICE_ID: 'eb75e163-1eed-46d5-827b-9369c53ad8d8',
      },
      storeIds: ['f58c34ac-7ee0-4d39-a663-ef5881b0a217'],
      storeInfos: [
        {
          storeId: 'storeid1',
          title: 'Test store 1',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
        },
        {
          storeId: 'storeid2',
          title: 'Test store 2',
          smallImage: null,
        },
      ],
      itemId: '60997a3960b20eb4a15d8d0f',
      price: null,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      externalId: 'e5444fe6-4862-46c6-8226-b0c41f2e0907',
      extTargetingId: 'e5444fe6-4862-46c6-8226-b0c41f2e0907-extTargetingId',
      title: '2050 Yonge copy - DO NOT USE - 4 Glass',
      createdDate: '2021-05-10T18:23:53',
      updatedDate: '2021-05-10T18:23:53',
      startDate: '2021-05-09T18:23:53',
      endDate: '2221-05-10T18:23:53',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: '4 Glass',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {
        SILVERWARE_PRICE_ID: '68e791f7-9a41-4330-b4fa-acb3a6b0ccaa',
      },
      storeIds: ['f58c34ac-7ee0-4d39-a663-ef5881b0a217'],
      itemId: '60997a3960b20eb4a15d8d04',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: true,
      outOfStockToday: true,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '80a249f0-2e1a-4506-97f1-56f2cb8fe982#2011',
      title: 'Balsamic Toast Store - Test - Wings',
      createdDate: '2022-12-30T10:05:53',
      updatedDate: '2022-12-30T10:05:53',
      startDate: '2022-12-29T10:05:53',
      endDate: '2222-12-30T10:05:53',
      displayRank: 5,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Wings',
          shortDescription: '',
          longDescription: '',
          smallImage: [
            'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Wings.jpg',
          ],
          mediumImage: [
            'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Wings-md.jpg',
          ],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {
        PRICE_CALCULATION_MODE: 'static',
      },
      privateAttributes: {},
      storeIds: ['66955a44-3a27-4720-9878-918d502c788a'],
      itemId: '63aeb801e4b0263317581610',
      price: 12020,
      optionGroupIds: ['63aeb801e4b02633175815e0', '63aeb801e4b0263317581588'],
      optionGroupSettings: [
        {
          optionGroupId: '63aeb801e4b02633175815e0',
          displayRank: 1,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: true,
          selectionType: 'SINGLE_SELECT',
          maxItemSelections: 1,
          minItemSelections: 1,
          applicableOrderTypes: null,
        },
        {
          optionGroupId: '63aeb801e4b0263317581588',
          displayRank: 1,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 5,
          minItemSelections: 0,
          applicableOrderTypes: null,
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: true,
      outOfStockToday: false,
      taxable: true,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '80a249f0-2e1a-4506-97f1-56f2cb8fe982#1118',
      title: 'Balsamic Toast Store - Test - Wings',
      createdDate: '2022-12-30T10:05:53',
      updatedDate: '2022-12-30T10:05:53',
      startDate: '2022-12-29T10:05:53',
      endDate: '2222-12-30T10:05:53',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Wings',
          shortDescription: '',
          longDescription: '',
          smallImage: [
            'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Wings.jpg',
          ],
          mediumImage: [
            'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Wings-md.jpg',
          ],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {
        PRICE_CALCULATION_MODE: 'static',
      },
      privateAttributes: {},
      storeIds: ['66955a44-3a27-4720-9878-918d502c788a'],
      itemId: '63aeb801e4b026331758158b',
      price: 12020,
      optionGroupIds: [
        '63aeb801e4b026331758158a',
        '63aeb801e4b0263317581580',
        '63aeb801e4b0263317581588',
      ],
      optionGroupSettings: [
        {
          optionGroupId: '63aeb801e4b0263317581580',
          displayRank: 3,
          inheritGroupSettings: false,
          defaultSelectedItemIds: ['63aeb801e4b026331758157f'],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'SINGLE_SELECT',
          maxItemSelections: 1,
          minItemSelections: 0,
          applicableOrderTypes: null,
        },
        {
          optionGroupId: '63aeb801e4b026331758158a',
          displayRank: 2,
          inheritGroupSettings: false,
          defaultSelectedItemIds: ['63aeb801e4b0263317581589'],
          mandatoryItemIds: [],
          selectionMandatory: true,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 11,
          minItemSelections: 5,
          applicableOrderTypes: null,
        },
        {
          optionGroupId: '63aeb801e4b0263317581588',
          displayRank: 1,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 5,
          minItemSelections: 0,
          applicableOrderTypes: null,
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: true,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '2874b0c8-d421-4ece-a2c8-5478b54e1583',
      extTargetingId: '2874b0c8-d421-4ece-a2c8-5478b54e1583-extTargetingId',
      title: 'Boston QA (Incentivio) - Almond Butter',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2022-10-20T10:47:39',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 4,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Almond Butter',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b56',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      maxQuantity: 3,
      minQuantity: 8,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '9e81666b-85ae-4a2c-8a68-b72c579202d7',
      extTargetingId: '9e81666b-85ae-4a2c-8a68-b72c579202d7-extTargetingId',
      title: 'Boston QA (Incentivio) - Almond Milk',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2023-01-27T07:01:59',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Almond Milk',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b54',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '8a898e7d-a743-4d91-a6b0-af3d8dd34c1e',
      extTargetingId: '8a898e7d-a743-4d91-a6b0-af3d8dd34c1e-extTargetingId',
      title: 'Boston QA (Incentivio) - Balsamic',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2022-07-15T05:07:30',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 3,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Balsamic',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75aec',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      maxQuantity: 0,
      minQuantity: 20,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '2266b7a0-243f-481e-9996-f1f734e7ad8a',
      extTargetingId: '2266b7a0-243f-481e-9996-f1f734e7ad8a-extTargetingId',
      title: 'Boston QA (Incentivio) - Blue Cheese',
      createdDate: '2021-12-30T06:07:25',
      updatedDate: '2023-01-27T07:01:55',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'FR',
          title: 'Blue Cheese',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Inactive',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75aea',
      price: 1000,
      optionGroupIds: ['607d039360b284ba22e75b34'],
      optionGroupSettings: [
        {
          optionGroupId: '607d039360b284ba22e75b34',
          displayRank: 1,
          inheritGroupSettings: false,
          defaultSelectedItemIds: null,
          mandatoryItemIds: null,
          selectionMandatory: false,
          selectionType: null,
          maxItemSelections: 0,
          minItemSelections: 0,
          applicableOrderTypes: null,
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      maxQuantity: 5,
      minQuantity: 3,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'c872691e-17b1-4159-951a-5430c43e934f',
      extTargetingId: 'c872691e-17b1-4159-951a-5430c43e934f-extTargetingId',
      title: 'Boston QA (Incentivio) - Blueberry',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2022-05-23T10:24:25',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Blueberry',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b01',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      maxQuantity: 3,
      minQuantity: 2,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'eda5bb24-b525-458b-8b73-c0cf3382f93c',
      extTargetingId: 'eda5bb24-b525-458b-8b73-c0cf3382f93c-extTargetingId',
      title:
        'Boston QA (Incentivio) - Chicken this is cost for extra 2.5$ for your order',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2021-04-19T04:14:11',
      startDate: '2021-04-18T04:14:11',
      endDate: '2221-04-19T04:14:11',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Chicken this is cost for extra 2.5$ for your order',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b11',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'eed36807-1086-40a5-83b7-76c30f947de3',
      extTargetingId: 'eed36807-1086-40a5-83b7-76c30f947de3-extTargetingId',
      title: 'Boston QA (Incentivio) - Chocolate',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2022-07-15T05:07:30',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Chocolate',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b06',
      price: 2000,
      optionGroupIds: ['609e3ab960b211f0ffe0ad0c'],
      optionGroupSettings: [
        {
          optionGroupId: '609e3ab960b211f0ffe0ad0c',
          displayRank: 1,
          inheritGroupSettings: false,
          defaultSelectedItemIds: null,
          mandatoryItemIds: null,
          selectionMandatory: false,
          selectionType: null,
          maxItemSelections: 0,
          minItemSelections: 0,
          applicableOrderTypes: null,
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '53e68a9f-9096-4f31-9e08-0e9610f55858',
      extTargetingId: '53e68a9f-9096-4f31-9e08-0e9610f55858-extTargetingId',
      title: 'Boston QA (Incentivio) - Coconut Cream',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2022-05-23T10:25:18',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 4,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Coconut Cream',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75aff',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      maxQuantity: 0,
      minQuantity: 5,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '9848c795-1920-4482-9000-7973df790bcb',
      extTargetingId: '9848c795-1920-4482-9000-7973df790bcb-extTargetingId',
      title: 'Boston QA (Incentivio) - Crab Cakes',
      createdDate: '2021-11-30T10:10:22',
      updatedDate: '2022-12-29T08:10:30',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Crab Cakes',
          shortDescription: 'Crab Cakes New - Toast',
          longDescription: '',
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20Crab%20Cakes-63ad4b46_1.png',
          ],
          mediumImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20Crab%20Cakes-63ad4b4d_1-md.png',
          ],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75af4',
      price: 29000,
      optionGroupIds: ['607d039360b284ba22e75af7'],
      optionGroupSettings: [
        {
          optionGroupId: '607d039360b284ba22e75af7',
          displayRank: 1,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'SINGLE_SELECT',
          maxItemSelections: 1,
          minItemSelections: 0,
          applicableOrderTypes: null,
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '9c3388d2-b78c-41dd-82d6-19240a86f8ad',
      extTargetingId: '9c3388d2-b78c-41dd-82d6-19240a86f8ad-extTargetingId',
      title: 'Boston QA (Incentivio) - Jasmine Rice',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2021-04-19T04:14:11',
      startDate: '2021-04-18T04:14:11',
      endDate: '2221-04-19T04:14:11',
      displayRank: 3,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Jasmine Rice',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b16',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'b40afbcc-1491-4ba8-b019-f2db9153d99d',
      extTargetingId: 'b40afbcc-1491-4ba8-b019-f2db9153d99d-extTargetingId',
      title: 'Boston QA (Incentivio) - Large',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2022-07-15T05:07:31',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Large',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b2e',
      price: 1500,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      maxQuantity: 5,
      minQuantity: 1,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '9ee90946-436a-4640-8215-3e57ce8e1d0f',
      extTargetingId: '9ee90946-436a-4640-8215-3e57ce8e1d0f-extTargetingId',
      title: 'Boston QA (Incentivio) - Large Portion',
      createdDate: '2021-05-14T08:54:17',
      updatedDate: '2022-07-15T05:07:31',
      startDate: '2021-05-13T00:00:00',
      endDate: '2221-05-14T23:59:59',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Large Portion',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '609e3ab960b211f0ffe0ad0f',
      price: 9500,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      maxQuantity: 5,
      minQuantity: 3,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '6946e7a3-65c5-4a48-bb1b-2c3cd538f43d',
      extTargetingId: '6946e7a3-65c5-4a48-bb1b-2c3cd538f43d-extTargetingId',
      title: 'Boston QA (Incentivio) - Mashed Potatoes',
      createdDate: '2022-01-24T07:05:08',
      updatedDate: '2022-07-15T05:07:31',
      startDate: '2021-04-18T00:00:00',
      endDate: '2221-04-19T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Mashed Potatoes',
          shortDescription: '',
          longDescription: '',
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20Mashed%20Potatoes-61ee4f9f_1.png',
          ],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b15',
      price: 0,
      optionGroupIds: ['607d039360b284ba22e75afa'],
      optionGroupSettings: [
        {
          optionGroupId: '607d039360b284ba22e75afa',
          displayRank: 1,
          inheritGroupSettings: false,
          defaultSelectedItemIds: null,
          mandatoryItemIds: null,
          selectionMandatory: false,
          selectionType: null,
          maxItemSelections: 0,
          minItemSelections: 0,
          applicableOrderTypes: null,
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'f178334d-3e56-4d93-916a-e40efa41ed42',
      extTargetingId: 'f178334d-3e56-4d93-916a-e40efa41ed42-extTargetingId',
      title:
        'Boston QA (Incentivio) - Matchstick apple slices tossed with lemon juice',
      createdDate: '2021-05-14T09:52:20',
      updatedDate: '2022-07-15T05:07:31',
      startDate: '2021-05-13T00:00:00',
      endDate: '2221-05-14T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Matchstick apple slices tossed with lemon juice',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '609e485460b211f0ffe0ad37',
      price: 500,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'e3583d30-38a0-46ac-8072-f317f2c5c596',
      extTargetingId: 'e3583d30-38a0-46ac-8072-f317f2c5c596-extTargetingId',
      title: 'Boston QA (Incentivio) - Medium',
      createdDate: '2021-04-19T04:14:11',
      updatedDate: '2021-04-19T04:14:11',
      startDate: '2021-04-18T04:14:11',
      endDate: '2221-04-19T04:14:11',
      displayRank: 2,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Medium',
          shortDescription: '',
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['a8bd1f53-6172-4f1f-b78b-50c7cf052151'],
      itemId: '607d039360b284ba22e75b0d',
      price: 0,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: true,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '640285242',
      extTargetingId: '640285242-extTargetingId',
      title: 'Brink Test Store - Crispy Chicken Salad',
      createdDate: '2022-10-17T07:34:03',
      updatedDate: '2022-10-17T07:34:03',
      startDate: '2022-10-16T07:34:03',
      endDate: '2222-10-17T07:34:03',
      displayRank: 0,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Crispy Chicken Salad',
          shortDescription:
            "Organic Spinach, Arugula, Rustic Romaine, Grilled Farmhouse Chicken, Cherry Tomato's, Classic Italian Dressing.\r\rCal 401- Fat 22g - Carbs 19g - Protein 25g - Fiber 14g ",
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {
        ItemId: '640251416',
      },
      storeIds: ['2ae986f9-ac5c-42a8-8c71-e36dbe591250'],
      itemId: '634d056be4b006945697c725',
      price: 5690,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MAIN',
      outOfStock: false,
      outOfStockToday: false,
      taxable: true,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '4018144',
      extTargetingId: '4018144-extTargetingId',
      title: 'Brink Test Store - Crumbled Meatballs',
      createdDate: '2022-10-17T07:34:03',
      updatedDate: '2022-10-17T07:34:03',
      startDate: '2022-10-16T07:34:03',
      endDate: '2222-10-17T07:34:03',
      displayRank: 0,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Crumbled Meatballs',
          shortDescription: null,
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['2ae986f9-ac5c-42a8-8c71-e36dbe591250'],
      itemId: '634d056be4b006945697c6ee',
      price: 4000,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: true,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: '640250461',
      extTargetingId: '640250461-extTargetingId',
      title: 'Brink Test Store - Double Meat',
      createdDate: '2022-10-17T07:34:03',
      updatedDate: '2022-10-17T07:34:03',
      startDate: '2022-10-16T07:34:03',
      endDate: '2222-10-17T07:34:03',
      displayRank: 0,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'Double Meat',
          shortDescription: null,
          longDescription: '',
          smallImage: [],
          mediumImage: [],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['DELIVERY', 'PICKUP'],
      extendedAttributes: {},
      privateAttributes: {},
      storeIds: ['2ae986f9-ac5c-42a8-8c71-e36dbe591250'],
      itemId: '634d056be4b006945697c714',
      price: 2500,
      optionGroupIds: [],
      optionGroupSettings: [],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MODIFIER',
      outOfStock: false,
      outOfStockToday: false,
      taxable: true,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae',
      extTargetingId: 'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae-extTargetingId',
      title: 'CESAR SALAD',
      createdDate: '2022-01-20T17:10:22',
      updatedDate: '2022-07-15T03:07:14',
      startDate: '2021-05-09T00:00:00',
      endDate: '2221-05-10T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'EN',
          title: 'SaladExtras',
          shortDescription: null,
          longDescription: null,
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68ddd_2.jpg',
          ],
          mediumImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68de5_1-md.jpg',
          ],
        },
        {
          langCode: 'FR',
          title: 'fr',
          shortDescription: '',
          longDescription: null,
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68ddd_2.jpg',
          ],
          mediumImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68de5_1-md.jpg',
          ],
        },
      ],
      status: 'Active',
      applicableOrderTypes: [],
      extendedAttributes: {},
      privateAttributes: {
        SILVERWARE_PRICE_ID: '405f85cf-fcac-4962-840a-178e2de3153b',
      },
      storeIds: ['f58c34ac-7ee0-4d39-a663-ef5881b0a217'],
      itemId: '30992a3a60b20eb4a15d8d83',
      price: 0,
      optionGroupIds: ['60997a3960b20eb4a15d8c92'],
      optionGroupSettings: [
        {
          optionGroupId: '60997a3960b20eb4a15d8c92',
          displayRank: null,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 1,
          minItemSelections: 1,
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MAIN',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
    {
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      externalId: 'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae',
      extTargetingId: 'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae-extTargetingId',
      title: 'CESAR SALAD',
      createdDate: '2022-01-20T17:10:22',
      updatedDate: '2022-07-15T03:07:14',
      startDate: '2021-05-09T00:00:00',
      endDate: '2221-05-10T23:59:59',
      displayRank: 1,
      displayInfo: [
        {
          langCode: 'FR',
          title: 'fr',
          shortDescription: 'These are different options for the cesar salad.',
          longDescription: 'Detailed long description for the cesar salad.',
          smallImage: [],
          mediumImage: [],
        },
        {
          langCode: 'SPA',
          title: 'Ensalada Cesar',
          shortDescription: null,
          longDescription: null,
          smallImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy_1.png',
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68ddd_2.jpg',
          ],
          mediumImage: [
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20%28MOD%29%20Allergy-62c68de5_1-md.jpg',
          ],
        },
      ],
      status: 'Active',
      applicableOrderTypes: ['TEST'],
      extendedAttributes: {},
      privateAttributes: {
        SILVERWARE_PRICE_ID: '405f85cf-fcac-4962-840a-178e2de3153b',
      },
      storeIds: ['f58c34ac-7ee0-4d39-a663-ef5881b0a217'],
      itemId: '30992a3a60b20eb4a15d2o13',
      price: 0,
      optionGroupIds: ['60997a3960b20eb4a15d8c92'],
      optionGroupSettings: [
        {
          optionGroupId: '60997a3960b20eb4a15d8c92',
          displayRank: null,
          inheritGroupSettings: false,
          defaultSelectedItemIds: [],
          mandatoryItemIds: [],
          selectionMandatory: false,
          selectionType: 'MULTI_SELECT',
          maxItemSelections: 1,
          minItemSelections: 1,
          applicableOrderTypes: ['DELIVERY', 'PICKUP'],
        },
      ],
      uom: '',
      sku: '',
      upc: '',
      maxItemSelections: 0,
      inheritParentOptions: false,
      invertParentTaxable: false,
      taxes: [],
      orderingChannels: ['MOBILE'],
      itemType: 'MAIN',
      outOfStock: false,
      outOfStockToday: false,
      taxable: false,
    },
  ],
  paging: {
    total: 22576,
    count: 1000,
    totalPages: 23,
    currentPage: 0,
  },
};
